import React, { useState } from 'react';
import axios from 'axios';
import './SuspendedClientsLogin.css';
import { Lock, Phone } from 'lucide-react';

function SuspendedClientsLogin({ onLoginSuccess }) {
  const [phone, setPhone] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleLogin = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    try {
      const response = await axios.post('/api/auth/suspended-clients-login', {
        phone,
        password
      });

      if (response.data.success) {
        localStorage.setItem('suspendedClientsToken', response.data.token);
        localStorage.setItem('suspendedClientsLoginTime', Date.now().toString());
        onLoginSuccess();
      } else {
        setError(response.data.message || 'Credenciales inv??lidas');
      }
    } catch (err) {
      setError(err.response?.data?.message || 'Error al iniciar sesi??n');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="suspended-clients-login-container">
      <div className="suspended-clients-login-card">
        <div className="suspended-clients-login-header">
          <div className="suspended-clients-login-icon">
            <Lock size={32} />
          </div>
          <h1>Panel de Clientes Suspendidos</h1>
          <p>Ingresa tus credenciales para continuar</p>
        </div>

        <form onSubmit={handleLogin} className="suspended-clients-login-form">
          <div className="suspended-clients-form-group">
            <label htmlFor="phone">
              <Phone size={18} />
              Tel??fono
            </label>
            <input
              type="tel"
              id="phone"
              value={phone}
              onChange={(e) => setPhone(e.target.value)}
              placeholder="829-387-6338"
              required
              disabled={loading}
            />
          </div>

          <div className="suspended-clients-form-group">
            <label htmlFor="password">
              <Lock size={18} />
              Contrase??a
            </label>
            <input
              type="password"
              id="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              placeholder="Ingresa tu contrase??a"
              required
              disabled={loading}
            />
          </div>

          {error && <div className="suspended-clients-error-message">{error}</div>}

          <button
            type="submit"
            className="suspended-clients-login-button"
            disabled={loading}
          >
            {loading ? 'Iniciando sesi??n...' : 'Iniciar Sesi??n'}
          </button>
        </form>

        <div className="suspended-clients-login-footer">
          <p>?? 2026 Panel de Administraci??n</p>
        </div>
      </div>
    </div>
  );
}

export default SuspendedClientsLogin;
